import { CargoTreinamento } from "../../../../domain/models/cargo_treinamento";
import { StyledDataGrid } from "../../../../../../common/components/styled_data_grid";
import { TablePagination } from "@mui/material";
import { useMemo } from "react";
import { GenerateCargoTreinamentoColumnsDefinition } from "../columns";
import { GridRowSelectionModel } from "@mui/x-data-grid-pro";

import FormContainer from "../../../../../../common/components/form_container";

/**
 * TabTreinamentos
 */

type Props = {
  loading: boolean,
  saving: boolean,
  gridRowSelectionModel: GridRowSelectionModel,
  cargoTreinamentos: CargoTreinamento[],
  page: number,
  rowsPerPage: number,
  totalItems: number,
  onPageChange: (page: number) => void,
  onRowsPerPageChange: (rowsPerPage: number) => void,
  onSelectionModelChange: (selectionModel: GridRowSelectionModel) => void,
};

export const TabTreinamentos = ({
  loading,
  gridRowSelectionModel,
  cargoTreinamentos,
  page,
  rowsPerPage,
  totalItems,
  onPageChange,
  onRowsPerPageChange,
  onSelectionModelChange,
}: Props) => {
  const columnsDef = useMemo(() => {
    return GenerateCargoTreinamentoColumnsDefinition();
  }, []);

  return (
    <>
      <div className='w-full bg-light-mode-2 dark:bg-dark-mode-2 p-4 rounded-[4px] border-[1px] border-border-light-mode dark:border-border-dark-mode mb-4'>
        <FormContainer title='Selecione os Treinamentos' arrangement='fullRow' border={false}>
          <>
            <StyledDataGrid
              tableName="cargos_cadastro"
              getRowHeight={() => 'auto'}
              disableColumnMenu={false}
              getRowId={(row: CargoTreinamento) => row.idTreinamento}
              checkboxSelection={true}
              rowSelectionModel={gridRowSelectionModel}
              onRowSelectionModelChange={onSelectionModelChange}
              columns={columnsDef}
              loading={loading}
              rows={cargoTreinamentos}
              rowCount={cargoTreinamentos.length}
              pageSizeOptions={[100]}
              paginationMode="server"
              paginationModel={{
                page: page,
                pageSize: rowsPerPage,
              }} />

            <TablePagination
              component="div"
              count={totalItems}
              page={page - 1}
              rowsPerPageOptions={[100]}
              onPageChange={(_, p) => onPageChange(p)}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={(e) => onRowsPerPageChange(parseInt(e.target.value))} />
          </>
        </FormContainer>
      </div>
    </>
  );
}